import React from 'react';
import { Layout } from 'antd';

import Content from '../../../components/Pages/LpReports/Profile';
import { displayName } from '../../../config';

const LpReportProfile: React.FC = (): JSX.Element => {
  document.title = `${displayName}: LP Report Details`;

  return (
    <Layout>
      <Content />
    </Layout>
  );
};

export default LpReportProfile;
